
import ComplexResponsiveComponent from "../complex-responsive-component";

export default class TableContainer extends ComplexResponsiveComponent {
  static jsClass = 'TableContainer';
}